<ng-container *ngIf="isClientSide && readyToLoad">
  <ng-container *ngIf="useBanta">
    <h1>Conversation</h1>
    <div class="alert alert-membership" *ngIf="requirementType === 'membership' && !isMember">
      Want to put your two cents in? We want to hear it! Posting comments is only available for <strong>TYT
        members</strong> in good standing.
      <br/>
      <br/>
      <a target="_blank" routerLink="/membership-benefits">Click here to learn more about becoming a TYT member.</a>
    </div>
    <div class="alert alert-membership" *ngIf="requirementType === 'registration' && !user">
      Want to put your two cents in? We want to hear it! Posting comments is only available for <strong>TYT
        community members</strong>.
        <br/>
        <br/>
      <a target="_blank" routerLink="/signup">Click here to sign up for free.</a>
    </div>
    <div class="alert alert-info" *ngIf="allowSwitchBack">
      <h1>Welcome to the new TYT.com commenting experience</h1>
      <p>
        We're laying the foundation for exciting new commenting features, coming soon. We're still working out the kinks,
        so if you are running into trouble you can <a href="javascript:;" (click)="switchBack()">switch back to OpenWeb</a>,
        but this option won't be around forever! Note that we are working on migrating older comments into the new system.
      </p>

      <a href="javascript:;" (click)="learnMore = !learnMore">
        What's new?
      </a>
      <ng-container *ngIf="learnMore">
        <ul>
          <li>Better support for real-time commenting during live streams</li>
          <li>Improved rich media support (images, GIFs, YouTube videos!)</li>
        </ul>

        What's coming next?

        <ul>
          <li>Migration of the comments from the old commenting system</li>
          <li>TYT.com-wide notifications (mentions, replies)</li>
        </ul>
      </ng-container>
    </div>

    <banta-comments topicID="{{identifier}}_comments"
      (signInSelected)="showSignIn()"
      [maxMessages]="2000"
      [maxVisibleMessages]="200"
      [customMenuItems]="customMenuItems"
      (permissionDeniedError)="showPermissionDenied($event)"
      (editAvatarSelected)="editAvatar()"
      (reported)="reportMessage($event)"
      (usernameSelected)="navigateToPublicProfile($event)"
      (avatarSelected)="navigateToPublicProfile($event)"
      (shared)="shareComment($event)"
      [postReplyLabel]="postReplyLabel"
      permissionDeniedLabel="Become a Member to Comment"
      [hashtags]="hashtags"
      [shouldInterceptMessageSend]="interceptReplySend.bind(this)"
      [allowAttachments]="true"
      [genericAvatarUrl]="'/assets/avatar.png'"
      >
      <div *bantaReplySendOptions>
        <ng-container *ngIf="canPrivateReply">
          <a class="send-mode" href="javascript:;"
            *ngIf="!isAPrivateReply"
            matTooltip="This reply will be sent publically."
            (click)="setPrivateReplyMode()">
            <mat-icon>public</mat-icon>
            Public
          </a>
          <a
            class="send-mode"
            href="javascript:;"
            *ngIf="isAPrivateReply"
            matTooltip="This reply will be sent as an email to the user."
            (click)="setPublicReplyMode()">
            <mat-icon>lock_outline</mat-icon>
            Private
          </a>
          <a class="send-mode-info-button" (click)="isAPrivateReply ? showPrivateReplyInfo() : showPublicReplyInfo()">
            <mat-icon>help</mat-icon>
          </a>
        </ng-container>
      </div>
    </banta-comments>

    <tyt-staging-note>
      Topic ID: <code>{{identifier}}_comments</code>
    </tyt-staging-note>

  </ng-container>

  <ng-container *ngIf="!useBanta">
    <div class="alert alert-warning" *ngIf="legacyOverride">
      <h1>The OpenWeb commenting experience will be going away</h1>
      <p>
        You're using the old OpenWeb commenting experience which will be retired soon. Having trouble with the new comments
        system? Please let us know! Email us at <a href="mailto:support@tytnetwork.com">support@tytnetwork.com</a>.
      </p>

      <a href="javascript:;" (click)="legacyOverride = false;">Click here to switch to the new commenting experience</a>

      <div>
        <em>
          Note: The new TYT.com commenting system does not sync in real-time with the older OpenWeb commenting solution.
        </em>
      </div>
    </div>

    <tyt-spotim [identifier]="identifier"
                [scrollToLoad]="scrollToLoad"
                [shareTitle]="shareTitle"></tyt-spotim>
  </ng-container>
</ng-container>